// Normalizes content for the read-only review/compare modals (Suggestions
// review preview + Enhance compare modal) so paragraphs render as distinct
// blocks regardless of whether the source is already HTML or plain text.
//
// Two input shapes show up in practice:
//   1. HTML with block tags joined without newlines, e.g.
//      "<p>First.</p><p>Second.</p>" (AI output — the prompt strips newlines
//      between tags). This must be passed through untouched.
//   2. Plain text with newline separators, e.g. "First.\n\nSecond." (editor
//      selections via textBetween, or a model that ignored the HTML rule).
//      Blank lines become separate <p> blocks; single newlines become <br>.
export function formatReviewHtml(content: string): string {
  if (!content) return "";
  // Already block-structured HTML — trust it.
  if (/<(p|h[1-6]|ul|ol|li|div|blockquote)\b/i.test(content)) return content;
  // No breaks to honor — wrap once so spacing rules still apply.
  if (!/\n/.test(content)) return `<p>${content}</p>`;
  const blocks = content
    .split(/\n\s*\n+/) // blank line → hard paragraph break
    .map((b) => b.trim())
    .filter(Boolean);
  const parts = blocks.length > 0 ? blocks : [content];
  return parts
    .map((b) => `<p>${b.replace(/\n+/g, "<br>")}</p>`)
    .join("");
}
